// src/components/quizzes/BonusYellowDiamonds.js
//
// Yellow Diamond Dash: catch the yellow diamonds only.
// Runs on the shared bonus-round engine (kit/BonusShell.js) — the
// BonusDiamonds look, bombs, bonus stars, clocks, combos, a new question
// every few right answers, and 🏁 End game. Same contract as before:
// BonusRouter renders <ThisGame onBonusComplete questions placeholderImage />.

import React from "react";
import BonusShell from "./kit/BonusShell";

// diamond config (only yellow gives points)
const DIAMONDS = [
  { key: "yellow", url: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/images%2Fdiamond-yellow.png?alt=media&token=9db1dd1d-d842-4cc5-b830-598e4847afb1", points: 5 },
  { key: "blue",   url: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/images%2Fdiamond-blue.png?alt=media&token=08a76d5c-c55d-49b6-8fa4-078f3a5cbd11",   points: -1 },
  { key: "red",    url: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/images%2Fdiamond-red.png?alt=media&token=5aff52b0-353a-4961-ae30-8498fc19173b",    points: -1 },
  { key: "green",  url: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/images%2Fdiamond-green.png?alt=media&token=b75ff5fe-d7f9-4015-a901-505a54c84b19",  points: -1 },
  { key: "purple", url: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/images%2Fdiamond-purple.png?alt=media&token=34c44b25-21df-4fbc-9644-4c73f91a25fa", points: -1 },
];

const SPAWN_WEIGHTS = { yellow: 0.7, blue: 0.075, red: 0.075, green: 0.075, purple: 0.075 };

const pickDiamond = () => {
  const entries = DIAMONDS.map(d => [d, SPAWN_WEIGHTS[d.key] ?? 1 / DIAMONDS.length]);
  const total = entries.reduce((s, [, w]) => s + w, 0);
  let r = Math.random() * total;
  for (const [d, w] of entries) {
    if ((r -= w) <= 0) return d;
  }
  return DIAMONDS[0];
};

const YellowDiamondsBonus = (props) => (
  <BonusShell
    {...props}
    title="Yellow Diamond Dash!"
    emoji="💛"
    sub="Catch the YELLOW diamonds — leave the other colours alone!"
    intro="Catch as many yellow diamonds as you can before the time runs out. Other colours take away a point, and bombs take away five. Press Start when you are ready."
    rules={[
      { icon: <img src={DIAMONDS[0].url} alt="" />, text: "Yellow diamond", pts: "+5" },
      { icon: <img src={DIAMONDS[1].url} alt="" />, text: "Any other colour", pts: "-1" },
    ]}
    init={() => ({})}
    prompt={() => null}
    spawn={() => pickDiamond()}
    check={(s, d) => d.key === "yellow"}
    label={(d) => <img src={d.url} alt={`${d.key} diamond`} draggable="false" />}
    shape="plain"
    itemSize={96}
    starsAt={[100, 200]}
    caughtLabel="Diamonds"
  />
);

export default YellowDiamondsBonus;
